import React from "react";

import { Text } from "@performyard/py-components";

import type { DecisionRow } from "../../../types";
import type { CompensationAuditLogEntry } from "./types";

import { formatAuditSubmittedDate } from "../utils";

import { SalaryUpdateLine, SubmittedBudgetLine } from "./lineItems";

export const buildAuditLogEntries = (
	managerId: string,
	baseGroupRowData: DecisionRow[],
	actorName: string | null
): CompensationAuditLogEntry[] => {
	const inReviewRows = baseGroupRowData.filter((row) => row.status === "in_review");
	const showSubmittedHeader =
		baseGroupRowData.length > 0 && baseGroupRowData.every((row) => row.status === "in_review");
	if (showSubmittedHeader) {
		return [
			{
				id: `${managerId}-submitted-activity-group`,
				content: (
					<div className="flex w-full flex-col gap-2">
						<Text weight="regular" size="caption">
							{formatAuditSubmittedDate(baseGroupRowData[0]?.updatedAt)}
						</Text>
						<SubmittedBudgetLine actorName={actorName} />
						{inReviewRows.map((user) => (
							<SalaryUpdateLine key={user._id} user={user} actorName={actorName} />
						))}
					</div>
				),
			},
		];
	}

	if (inReviewRows.length > 0) {
		return [
			{
				id: `${managerId}-salary-updates`,
				content: (
					<div className="flex w-full flex-col gap-2">
						{inReviewRows.map((user) => (
							<SalaryUpdateLine key={user._id} user={user} actorName={actorName} />
						))}
					</div>
				),
			},
		];
	}

	return [];
};
